import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import DashboardDetailsCrumbsRow from '../../components/DashboardDetailsCrumbsRow/DashboardDetailsCrumbsRow';
import { DashboardPlates } from '../../constants/dashboard';
import { dashboardStore } from '../../store/dashboardStore';
import { orderingChannelsIcons, orderingChannelsLangKeys, ORDERING_CHANNELS } from '~/constants/orderingChannels';
import theme from '~/constants/styles';
import { TOrderingChannelsReportBody } from '~/types/reports';
import Icon from '~/view/components/Controls/Icon/Icon';
import Text from '~/view/components/Text/Text';
import GridTable, { TGridColumnTitle } from '~/view/containers/GridTable';

/**
 * Warning!!! Only ORDERS and REVENUE is true
 */
const columnsTitles: Record<DashboardPlates, TGridColumnTitle<undefined>[]> = {
  [DashboardPlates.ORDERS]: [{ title: 'source' }, { title: 'total_completed_orders_by_channel' }],
  [DashboardPlates.REVENUE]: [{ title: 'source' }, { title: 'total_revenue' }],
  [DashboardPlates.CRM]: [{ title: 'source' }, { title: 'total_customers' }],
  [DashboardPlates.MARKETING]: [{ title: 'source' }, { title: 'promocodes_value' }],
};

/**
 * Warning!!! Only ORDERS and REVENUE is true
 */
const secondColumnKey: Record<DashboardPlates, keyof TOrderingChannelsReportBody> = {
  [DashboardPlates.ORDERS]: 'ordersCount',
  [DashboardPlates.REVENUE]: 'revenue',
  [DashboardPlates.CRM]: 'averageCheck',
  [DashboardPlates.MARKETING]: 'averageCheck',
};

const firstColumn = (report: TOrderingChannelsReportBody): ReactElement => {
  return (
    <div className="d-flex flex-row align-items-center gap-10">
      <Icon name={orderingChannelsIcons[report.channelId as ORDERING_CHANNELS]} size={24} color={theme.colors.gray2} />
      <Text type="list-row" text={orderingChannelsLangKeys[report.channelId as ORDERING_CHANNELS]} />
    </div>
  );
};

const secondColumn = (report: TOrderingChannelsReportBody): ReactElement => {
  return <Text type="list-row" text={report[secondColumnKey[dashboardStore.selectedPlate!]]} />;
};

const DashboardDetailsChannelsCrumb: FC = observer((): ReactElement | null => {
  if (!dashboardStore.selectedPlate) return null;

  return (
    <GridTable
      gridTemplateClass="dashboard-details-crumbs-row__grid-template"
      columnTitles={columnsTitles[dashboardStore.selectedPlate]}
      className="m-0"
    >
      {Object.values(dashboardStore.reportOrderingChannel).map((value, index) => (
        <DashboardDetailsCrumbsRow key={index} index={index} firstColumn={firstColumn(value)} secondColumn={secondColumn(value)} />
      ))}
    </GridTable>
  );
});

export default DashboardDetailsChannelsCrumb;
